
<div class="home-video-wrapper w-100 H-100 H-100-full" [ngClass]="{'loaded': iframeIsLoaded}">
    <div class="home-content-wrapper  w-100 H-100 H-100-full">
        <div class="content-conainer">
            <h1 class="heading1 font-bold  heading-1-m f-white" [innerHtml]="content.title"></h1>
        </div>
        <a class="link1-mobile link-white f-white" routerLink="/works" [ngClass]="{'d-none': screenWidth  > 1024}">{{content.button_label}}</a>
        <a class="link1 link-white f-white" routerLink="/works" [ngClass]="{'d-none': screenWidth <= 1024}">{{content.button_label}}</a>
    </div>


    <div *ngIf="not_suspend && screenWidth > 1024" #videoplayer class="home-video-container">
        <iframe 
            [ngClass]="{'loaded': iframeIsLoaded}"
            (load)="iframeLoaded()" 
            class="e2e-iframe-trusted-src" 
            loading="lazy"
            *ngIf="videourl" 
            [src]="videourl"
            frameborder=0   
            allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen">
        </iframe>
    </div>


    <div *ngIf="not_suspend && screenWidth < 1024" #videoplayerMobile class="home-video-container">
        <iframe 
            [ngClass]="{'loaded': iframeIsLoadedMobile}"
            (load)="iframeLoadedMobile()" 
            class="e2e-iframe-trusted-src" 
            loading="lazy"
            *ngIf="videourlMobile" 
            [src]="videourlMobile"
            frameborder=0   
            allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen">
        </iframe>
    </div>

    <img *ngIf="!not_suspend && screenWidth <= 1024" src="{{content.image}}">
    <div class="scroll-thumb index-medium" [ngClass]="{'show': notScrolled}">
        <span class="f-white scroll-text f-weight-medium">SCROLL</span>
    </div>

</div>
<div class="view-port-detect" 
inViewport
[inViewportOptions]="{ threshold: 0.0001 }"
(inViewportAction)="onIntersection($event)">
</div>

